// @flow

import * as React from 'react';
import { I18n } from 'react-redux-i18n';

type Props = {
  items: string[],
  itemSelected: string,
  onItemSelected: Function,
  children: React.Node,
  bottomAlign?: boolean,
}

class SideMenu extends React.PureComponent<Props> {
  static defaultProps = {
    bottomAlign: false,
  };


  render() {
    if (!this.props.items) {
      return false;
    }
    return (
      <div className={`sidebar ${this.props.bottomAlign ? 'bottom' : ''}`}>
        <div className="menu">
          {
            this.props.items.map((item: string) => (
              <div
                key={item}
                className={`menu-item menu-item${this.props.itemSelected === item ? '--selected' : ''}`}
                onClick={() => this.props.onItemSelected(item)}
              >
                <div
                  className="item-button"
                >
                  <p>
                    {I18n.t(`OFFICE.${item.toUpperCase()}`).toUpperCase()}
                    {/*<Translate value={`OFFICE.${item.toUpperCase()}`} />*/}
                  </p>
                </div>
              </div>
            ))
          }
        </div>
        <div className="content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default SideMenu;
